/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';

const ContentReviewItemHeaderNameDate = styled.div`
  top: 0px;
  position: absolute;
  height: 13px;
  font-family: 'Brandon Text';
  line-height: 18px;
`;

export const ReviewModalWrapper = styled.div`
  & .modal-root {
    display: flex !important;
  }
`;

export const ContentReviewCustomerName = styled<any>(
  ContentReviewItemHeaderNameDate
)`
  left: 0px;
  color: #183558;
  font-size: 16px;
  font-weight: 700;

  ${props => (props.isModal ? 'padding-left: 2em' : '')};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 20px;
    padding-left: 0.8em;
  }
`;

export const ContentReviewDate = styled<any>(ContentReviewItemHeaderNameDate)`
  right: 0px;
  color: #757989;
  font-size: 14px;
  font-weight: 200;

  ${props => (props.isModal ? 'padding-right: 2em' : '')};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding-right: 1em;
  }
`;

export const ContentReviewSectionBase = styled.div<any>`
  background-color: ${props => (props.whiteBackground ? '#ffffff' : 'auto')};
  padding: 19px 0px;
  order: 1;
  position: relative;
  vertical-align: top;

  & h3 span {
    display: block;
    height: 18px;
    color: #183558;
    font-family: 'Brandon Text';
    font-size: 24px;
    font-weight: 700;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: 19px;
    padding-bottom: 1em;
  }
  & h3 {
    color: #757989;
    font-family: 'Brandon Text';
    font-size: 22px;
    font-weight: 300;
  }
`;

export const ContentReviewArea = styled<any>(ContentReviewSectionBase)`
  && {
    min-width: ${props => props.minWidth};
    order: ${props => props.order};
    margin-top: 2em;
    ${props => (props.isModal ? 'padding: 2em' : '')};
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    && {
      ${props => (!props.isModal ? 'padding: 1em' : '')};
      ${props => (!props.isModal ? 'width: 100%' : '')};
    }
  }
`;

export const ContentReviewCustomerVehicleLocationWrapper = styled.div`
  position: relative;
  margin-top: 0.25em;
  margin-bottom: 2em;
`;

const ContentReviewItemHeaderVehicleLocation = styled.div`
  top: 0px;
  position: absolute;
  height: 13px;
  font-family: 'Brandon Text';
  line-height: 18px;
`;

export const ContentReviewCustomerVehicle = styled<any>(
  ContentReviewItemHeaderVehicleLocation
)`
  right: 0px;
  color: #757989;
  font-size: 12px;
  font-weight: 200;
`;

export const ContentReviewCustomerLocation = styled<any>(
  ContentReviewItemHeaderVehicleLocation
)`
  left: 0px;
  color: #757989;
  font-size: 12px;
  font-weight: 200;
`;

export const ContentReviewBody = styled.div<any>`
  color: #757989;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.35px;
  text-align: left;
  max-height: ${props => (props.restrictHeight ? '6em' : 'auto')};
  overflow: hidden;
  margin-top: 1em;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    min-height: ${props => (props.restrictHeight ? '6em' : 'auto')};
  }
`;

export const ContentReviewSectionSeparatorBase = styled.div`
  height: 1px;
  background-color: #d9dde9;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
`;

export const ContentReviewSectionSeparator = styled<any>(
  ContentReviewSectionSeparatorBase
)`
  order: ${props => props.order};
`;

const ReviewStarsTextBase = styled.span`
  left: 0px;
  color: #183558;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.35px;
  text-align: left;
  display: inline-block;
  whitespace: nowrap;
`;

export const ReviewStarsText = styled<any>(ReviewStarsTextBase)`
  width: 50%;
`;
export const ContentReviewStars = styled.div<any>`
  position: relative;

  && {
    order: ${props => props.order};
    text-align: left;
    width: 100%;
  }
`;
